import React from 'react';
import { useLocation } from 'react-router-dom';

import { SecondaryButton } from '@components/Button/variants';
import FlexLink from '@components/FlexLink';
import IconGear from '@components/Images/Rebranding/IconGear';
import { useAppContext } from '@contexts/AppContext';
import { useEventTracking } from '@hooks';
import { edit_user_email_settings_path, forum_path, new_forum_post_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';
import { User } from '@utils/backend-api/currentUser';

import NewForumPostButton from '../NewForumPostButton';
import styles from './styles.module.scss';

const EMAIL_SETTINGS = 'Email settings';

export default function ForumHeader({ currentUser }: { currentUser: User }) {
  const { isWebview } = useAppContext();
  const location = useLocation();
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.ForumHeader,
  });

  const handleForumHomeClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.BackToForum, clickText: 'The Information Forum' }));
  };

  const handleEmailSettingsClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.EmailSettings, clickText: EMAIL_SETTINGS }));
  };

  return (
    <Track>
      <div className="border-0 border-b border-solid border-grayscale-gray bg-white">
        <div className="container-padded container">
          <div className={styles.headerContent}>
            <div className={styles.headerDescription}>
              <FlexLink
                href={forum_path()}
                className="font-suisse-works text-headline-sm text-black sm:text-headline-lg"
                onClickCapture={handleForumHomeClick}
              >
                The Information <span className="text-primary-magenta">Forum</span>
              </FlexLink>
              <div className="text-center font-suisse-neue text-subheadline-sm text-grayscale-gray sm:text-left">
                Follow and join in on serious discussions about tech, finance and media with others
                who share your same passion for the topics. No noise.
              </div>
            </div>
            <div className={styles.headerActions}>
              {location.pathname !== new_forum_post_path() && (
                <div className={styles.writePostBtnWrapper}>
                  <NewForumPostButton />
                </div>
              )}
              {currentUser?.permitted_to_comment && !isWebview && (
                <SecondaryButton
                  as="link"
                  href={edit_user_email_settings_path()}
                  size="small"
                  fullWidth={true}
                  onClickCapture={handleEmailSettingsClick}
                >
                  <IconGear className="mr-8 w-16" /> {EMAIL_SETTINGS}
                </SecondaryButton>
              )}
            </div>
          </div>
        </div>
      </div>
    </Track>
  );
}
